import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 16 16',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <path
      fill={fill}
      d="M12.5,11a2.73,2.73,0,0,0-1.9.8L5.94,9A2.33,2.33,0,0,0,6,8.5a2.5,2.5,0,0,0-.18-.91L11,4.5A2.53,2.53,0,0,0,14.5,4,2.53,2.53,0,0,0,14,.5a2.53,2.53,0,0,0-3.5.5A2.46,2.46,0,0,0,10,2.5a2.92,2.92,0,0,0,.2.9L5,6.5l0,0A2.46,2.46,0,0,0,3.5,6a2.5,2.5,0,1,0,1.82,4.21L10,13c0,.2-.1.3-.1.5a2.5,2.5,0,0,0,5,0A2.39,2.39,0,0,0,12.5,11Z"
    />
  </svg>
);
export default SVG;
